module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "page section-header text-center"
  }, [_c('h1', [_vm._v("About Us")])]), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "rte"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "custom-content"
  }, [_c('div', {
    staticClass: "custom__item custom__item--1537787486018 one-whole align--center"
  }, [_c('div', {
    staticClass: "medium-up--text-center"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v(" LILPICKS- FASHION FOR LIL ONES")]), _vm._v(" "), _c('div', {
    staticClass: "rte-setting"
  }, [_c('p', [_vm._v("\nLilPicks is a child-centered brand focusing on styling the little bundles of joy since it's inception in the year, 2015. The idea of LilPicks came from a mother and budding entrepreneur,\n Mrs. Riya Gupta (Founder, LilPicks) with a determination in mind to venture into the section of kids to make them look trendy.\n")]), _vm._v("\nOver a span of just 4+ years, LilPicks has triumphantly delivering kids garments catering to all the needs of every season. From\nfestivals, birthdays, to weddings, and casual, semi-formal, formal, Indian, westerns, Indo western to top trends, LilPicks has all that you need for your kid to go all glam-sham!\n"), _c('p', [_vm._v("\nThe brand takes an extra care of the comfort of the child while also keeping in mind the latest fashion trends. The use of cotton lining\nand threads makes our garments highly appreciated not only by the children but in accordance with the standards of clothing. We pay keen attention to each child’s body \nstructure and their age to ensure the suitability of the garment.\n")]), _vm._v("\nWith subject to fashion, LilPicks is one of the most loved brands in the Kids section of E-Commerce Marketplace like Myntra, Firstcry,\nHopscotch, LittleMuffet, AJIO, Shopperstop And Many More……..\n"), _c('p', [_vm._v("\nWe Have Supplies to Many Curated Retail Stores Pan India.\n")]), _vm._v("\nIn 2020, We started catering worldwide and Successful Delivered Orders to Singapore, Malaysia and Dubai.\n"), _c('p', [_vm._v("\nLet your little one vouch of his amazing Picks at LilPicks!\n")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75c9d27c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/aboutUs.vue
// module id = 2321
// module chunks = 0